import {FieldRecord} from './field-record';
import {FormRichFieldConfig} from './form-rich-field-config';
import {FormFieldButtonConfig} from "./form-field-button-config";

export class FormFieldConfig {

  field?: string;

  class?: string;

  label?: string;

  useOffLabel?: boolean;

  onIcon?: string;

  offIcon?: string;

  type: string | FormFieldConfig.TYPE;

  min?: number;

  max?: number;

  column: number;

  required?: boolean;

  optionValue?: string;

  filter?: boolean;

  // PickList: enable drag & drop between/within lists. Defaults to true.
  dragdrop?: boolean;

  richFieldConfig?: FormRichFieldConfig;

  format?: string;

  leftButton?: FormFieldButtonConfig;

  buttons?: FormFieldButtonConfig[];

  rightButton?: FormFieldButtonConfig;

  focused?: boolean = false;

  feedback?: boolean = true;

  maxDate?: Date;

  minDate?: Date;

  fieldIconLeft?: string;

  fieldIconRight?: string;

  labelCheckbox?: boolean = false;

  headerTitle1?: string;

  headerTitle2?: string;

  accept?: string;
  dateSelectionMode?: "single" | "multiple" | "range";
  dateView?: "date" | "year" | "month";

  optionValues?: FieldRecord<any>[];
  input?: (event: any, event2: any, inputField: HTMLInputElement) => void;
  changed?: (event: any, event2: any) => void;
  labelCheckboxChanged?: (event: any, event2: any) => void;
  options?: (record: any, query?: any) => FieldRecord<any>[];
  findOptionText?: (value: any) => string;
  hidden?: (record: any) => boolean;
  disabled?: (record: any) => boolean;
  icon?: (id: string, formRecord: any) => string;
  iconValue?: (event: string, formRecord: any) => string;
  validate?: (record: any) => string;
  style?: (record: any) => string;
  mapValue?: (record: any) => string;
  fractionDigits?: (record: any) => number;
  hybridType?: (record: any) => FormFieldConfig.TYPE;
}

export module FormFieldConfig {
  export enum TYPE {
    NONE = 'none',
    HYBRID = 'hybrid', //TEXT,DATE,DATETIME,TIME,CHECKBOX,PASSWORD,INTEGER,DECIMAL
    CHECKBOX = 'checkbox',
    TEXT = 'text',
    INTEGER = 'integer',
    DECIMAL = 'decimal',
    EMAIL = 'email',
    PASSWORD = 'password',
    TEXTAREA = 'textarea',
    RICHTEXTAREA = 'richtextarea',
    DROPDOWN = 'dropdown',
    AUTOCOMPLETE = 'autocomplete',
    MULTISELECT = 'multiselect',
    MULTISELECT_GROUP = 'multiselect_group',
    MULTITEXT = 'multitext',
    LISTBOX = 'listbox',
    PICKLIST = 'picklist',
    FILEUPLOAD = 'fileupload',
    CRON = 'cron',
    DATE = 'date',
    DATETIME = 'datetime',
    TIME = 'time',
    RICHFIELD = 'richfield',
    ADDDELETEFIELD = 'adddeletefield',
    TABLEFORMFIELD = 'tableformfield',
    SINGLERICHFIELD = 'singlerichfield',
    MAPFIELD = 'mapfield',
    BUTTONS = 'buttons'
  }
}
